export default __webpack_public_path__ + "static/media/boost-02.4a8662ac.webp";